/**
 * @file components/SecondaryContent/component.js
 */

import CardText from "../../../CardText/component";

/**
 * The SecondaryContent component.
 *
 * Component will display secondary Content Package data
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the SecondaryContent component
 */
export default function SecondaryContent({ secondary }) {
    return (
        <div className="secondaryContent" data-testid="secondary-content">
            {secondary.map((props, idx) => {
                return (
                    <div
                        key={`${props.key}-${idx}`}
                        data-feature-instance="secondary-related"
                        data-feature-position={idx + 1}
                        data-testid="secondary-content-attribution"
                    >
                        <CardText
                            {...props}
                            key={`${props.key}-${idx}`}
                            className="relatedCard"
                            departments={{}}
                            text={props.title}
                        />
                    </div>
                );
            })}
        </div>
    );
}
